import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {
  // Variable pour déterminer si le composant est affiché de manière autonome ou via les paramètres
  isStandalone: boolean = false;

  constructor(
    private location: Location,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Vérifier si l'URL actuelle est /about (accès direct) ou contient /settings (via les paramètres)
    this.isStandalone = this.router.url === '/about';
  }

  // Méthode pour gérer le retour en arrière
  goBack(): void {
    this.location.back();
  }
}
